<button
  [matMenuTriggerFor]="dynamicColumns"
  [matMenuTriggerData]="{ closeOnClick: false }"
  class="btn btn-secondary"
  (click)="$event.stopPropagation()"
>
  Columns ({{ columnActiveCount() }}) <caret></caret>
</button>

<mat-menu #dynamicColumns="matMenu" xPosition="before" class="column-menu">
  <ng-container *ngFor="let column of configuration | keyvalue: sortList">
    <button
      *ngIf="column.value.hasPermission"
      mat-menu-item
      (click)="toggle(column.key); $event.stopPropagation()"
    >
      <i
        class="column-check fa"
        [class.column-check-selected]="column.value.active"
        [class.fa-check-square]="column.value.active"
        [class.fa-square]="!column.value.active"
      ></i>
      {{ column.value.label }}
    </button>
  </ng-container>
</mat-menu>
